import FlexWidthImage from './component'
export default FlexWidthImage
